import { BadgeCheck, FileSearch, Scale } from "lucide-react";

const points = [
  {
    icon: BadgeCheck,
    title: "Certified means proven, not promised",
    text: "Every certified report carries the SHA-256 fingerprint and UTC capture timestamp of every photo, plus device attestation. It doesn't ask to be believed — it can be checked.",
  },
  {
    icon: FileSearch,
    title: "Anyone can verify it",
    text: "The report ends with a verification page any third party — landlord, tenant, mediator, or judge — can follow to confirm nothing was altered after capture.",
  },
  {
    icon: Scale,
    title: "Built for the moment it counts",
    text: "In a deposit dispute, an uncertified photo is a claim. A certified, countersigned report is court-presentable evidence — structured, dated, and signed by every party.",
  },
];

export const Certification = () => (
  <section data-testid="certification-section" className="bg-[#14213D] py-24 px-6 md:px-12 relative overflow-hidden">
    <div className="stamp-watermark" style={{ backgroundImage: "url(/assets/veristamp_icon_master.svg)", backgroundPosition: "105% 130%" }} />
    <div className="max-w-7xl mx-auto relative">
      <div className="flex items-center gap-3">
        <span className="inline-flex items-center gap-2 border border-[#C9A227]/50 rounded-full px-4 py-1.5">
          <BadgeCheck className="w-4 h-4 text-[#C9A227]" />
          <span className="text-[#C9A227] text-xs font-semibold tracking-widest uppercase">The certification</span>
        </span>
      </div>
      <h2 data-testid="certification-headline" className="mt-6 font-heading font-extrabold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-[#F7F6F2] max-w-3xl">
        Photos are easy. <span className="text-[#C9A227]">Certified evidence</span> is what wins.
      </h2>
      <p className="mt-5 text-base text-[#F7F6F2]/70 leading-relaxed max-w-2xl">
        Certification is the difference between "here are some pictures" and a document the other side can't argue with.
      </p>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-8">
        {points.map((p, i) => (
          <div
            key={i}
            data-testid={`certification-card-${i}`}
            className="border border-white/10 rounded-xl p-8 bg-[#2C3B5E]/30 backdrop-blur-sm transition-all duration-300 hover:border-[#C9A227]/50 hover:-translate-y-0.5"
          >
            <div className="w-11 h-11 rounded-lg bg-[#C9A227] flex items-center justify-center">
              <p.icon className="w-5 h-5 text-[#14213D]" strokeWidth={2} />
            </div>
            <h3 className="mt-5 font-heading font-bold text-lg text-[#F7F6F2]">{p.title}</h3>
            <p className="mt-2 text-sm text-[#F7F6F2]/65 leading-relaxed">{p.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
